export * from './header.component';



// WEBPACK FOOTER //
// ./src/components/app/header/index.ts